import { apiUrl } from "../constans";
import apiClient from '../libs/axios';

const API_BASE = `${apiUrl}/v2/inmuebles`;

// Tope del contrato: el endpoint rechaza (422) mas de 500 ids por solicitud.
export const MAX_IDS_POR_SOLICITUD = 500;

const property = {
    namespaced: true,
    state: {
        loading: false,
        error: null,
        // Resultado del ultimo lote encolado: { total_recibidos, total_en_proceso,
        // ids_en_proceso, ids_ignorados }
        ultimoResultado: null,
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },

        setError(state, error) {
            state.error = error;
        },

        clearError(state) {
            state.error = null;
        },

        setUltimoResultado(state, resultado) {
            state.ultimoResultado = resultado;
        },

        clearUltimoResultado(state) {
            state.ultimoResultado = null;
        },
    },

    actions: {
        /**
         * Encola la eliminacion masiva de inmuebles.
         *
         * Ojo: un 200 significa "encolado", no "borrado". El job corre en la cola
         * `database` y el borrado real ocurre cuando el worker lo toma.
         */
        async deleteMultiplePropertiesAction({ commit }, payload) {
            commit('setLoading', true);
            commit('clearError');
            try {
                // payload: arreglo de ids (modo de siempre) o el cuerpo del modo
                // por agente { type, ids?, email, incluir_hijos }.
                const body = Array.isArray(payload) ? { ids: payload } : payload;
                const response = await apiClient.post(`${API_BASE}/delete-multiple`, body);
                const data = response.data.data || {};
                commit('setUltimoResultado', data);
                return data;
            } catch (error) {
                commit('setError', error.response?.data?.data || 'Error al iniciar la eliminacion masiva');
                throw error;
            } finally {
                commit('setLoading', false);
            }
        },

        /**
         * Inmuebles por agente (docs/inmuebles-por-agente-contrato-api.md en el
         * backend): selector de agentes, resumen con conteos y traslado.
         */
        async agentesPorAgenteAction(_, search) {
            const response = await apiClient.get(`${API_BASE}/por-agente/agentes`, {
                params: search ? { search } : {},
            });
            return response.data.data || [];
        },

        async resumenPorAgenteAction(_, email) {
            const response = await apiClient.get(`${API_BASE}/por-agente/resumen`, { params: { email } });
            return response.data.data;
        },

        // Sincrono: al responder los inmuebles ya cambiaron de agente.
        async trasladarInmueblesAction({ commit }, body) {
            commit('setLoading', true);
            commit('clearError');
            try {
                const response = await apiClient.post(`${API_BASE}/trasladar`, body);
                return response.data;
            } finally {
                commit('setLoading', false);
            }
        },
    },
};

export default property;
